/**
 * Data Table Components
 *
 * Advanced table components for building feature-rich data tables
 * with sorting, pagination, filtering, and row selection.
 *
 * Built on TanStack Table for robust table functionality.
 */

// Main DataTable component
export { DataTable } from './DataTable';
export type { DataTableProps } from './DataTable';

// Sub-components
export { DataTableColumnHeader } from './DataTableColumnHeader';
export type { DataTableColumnHeaderProps } from './DataTableColumnHeader';

export { DataTablePagination } from './DataTablePagination';
export type { DataTablePaginationProps } from './DataTablePagination';

export { DataTableToolbar } from './DataTableToolbar';
export type { DataTableToolbarProps, ActiveFilter } from './DataTableToolbar';

export { DataTableFilterBuilder } from './DataTableFilterBuilder';
export type {
  DataTableFilterBuilderProps,
  FilterRule,
  FilterOperator,
  ColumnType,
  SavedFilter,
} from './DataTableFilterBuilder';

// Export all types (excluding DataTableProps which is already exported above)
export type {
  TableData,
  FilterConfig,
  DataTableColumn,
  ExportFormat,
  ExportOptions,
  PaginationConfig,
  DataTableConfig,
  DataTableInstance,
  ExportData,
  ColumnVisibilityState,
  ColumnFiltersState,
  SortingState,
  RowSelectionState,
  ColumnOrderState,
  ColumnSizingState,
  PaginationState,
  Row,
  ColumnDef,
} from './types';

// Export utility functions
export {
  exportToCSV,
  exportToExcel,
  exportToPDF,
  exportData,
} from './utils/export';
